import { Crown, Trophy } from "lucide-react";
import { formatEther } from "viem";

interface CurrentKingInfoProps {
  currentKing: string | undefined;
  currentStake: bigint | undefined;
  rewardPool: bigint | undefined;
}

export const CurrentKingInfo = ({ currentKing, currentStake, rewardPool }: CurrentKingInfoProps) => {
  return (
    <div className="grid gap-4 text-center">
      <div className="flex items-center justify-center gap-2 text-lg">
        <Trophy className="h-5 w-5 text-primary" />
        <span className="font-semibold">Current King:</span>
        <span className="font-mono">
          {currentKing ? `${currentKing.slice(0, 6)}...${currentKing.slice(-4)}` : "No King Yet"}
        </span>
      </div>
      <div className="text-lg">
        <span className="font-semibold">Current Stake:</span>{" "}
        <span className="text-primary">{currentStake ? formatEther(currentStake) : "0"} MATIC</span>
      </div>
      <div className="text-lg">
        <span className="font-semibold">Reward Pool:</span>{" "}
        <span className="text-primary">{rewardPool ? formatEther(rewardPool) : "0"} MATIC</span>
      </div>
    </div>
  );
};